import { first } from 'lodash'
import { GeneralAPI } from '../../apis/GeneralAPI'
import LegalPage from '../../components/LegalPage'
import { buildLegalMeta, getLegalPageTitle } from '../../helpers/legalPages'

export default function EndUserAgreementPage(props) {
    return <LegalPage {...props} />
}

export async function getStaticProps() {
    const data = first(await GeneralAPI.getPageBySlug('end-user-agreement'))
    const title = getLegalPageTitle(data, 'End User Agreement')

    if (!data) {
        return {
            notFound: true,
            revalidate: 10,
        }
    }

    const { meta, metaTitle } = buildLegalMeta({
        data,
        title,
        path: '/terms/end-user-agreement',
    })

    return {
        props: {
            currentPath: '/terms/end-user-agreement',
            data,
            meta,
            metaTitle,
            title,
        },
        revalidate: 10,
    }
}
